// Component for ErrorModal to display errors as they come back from API calls
import * as React from 'react';

import {
  Alert,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {
  apiErrorSlice
} from '../error/apiError';

import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { useEffect } from 'react';

const ErrorModal = (props) => {

  const dispatch = useDispatch();

  const handleClose = () => {
    // Clear error and hide modal
    dispatch(apiErrorSlice.actions.clearError());
  };

  const errorType = useSelector(state => state.apiError.errorType);
  const customMessage = useSelector(state => state.apiError.errorMsg);
  const open = errorType !== null && errorType !== undefined;

  const [msg, setMsg] = useState(null)

  useEffect(() => {
    if (open) {
      setMsg(
        errorType === "ServerError" ? 'Server Error. Please try again.' : 
        errorType === "Forbidden" ? 'Not authorized. Please check your Active Directory group membership.' :
        errorType === "CustomError" ? customMessage :
        'Unknown error'
      )
    }
  }, [open])

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center'}}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      action={action}
    >
      {msg !== '' ? (
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%', fontSize: 16, p: 4 }}>
          {msg}
        </Alert>
      ) : (
        // Prevent laggy text changing while closing
      <Typography>
        {' '}
      </Typography>)}
    </Snackbar>
  );
};
export default ErrorModal;

